import accountOverviewRedux from 'Modules/accounts/views/overview/redux/reducer';
import purgeAccountRedux from 'Modules/accounts/views/components/purgeAccount/redux/reducer';
import createEditAccountRedux from 'Modules/accounts/views/components/createEditAccount/redux/reducer';
import changeStatusAccountRedux from 'Modules/accounts/views/components/changeStatus/redux/reducer';
import resetCompAuthenticationRedux from 'Modules/accounts/views/components/resetCompanyAuthentication/redux/reducer';
import advancedFiltersRedux from 'Modules/accounts/views/main/.components/AdvancedFilters/redux/reducer';
import scheduledReportsRedux from 'Modules/accounts/.components/scheduledReports/redux/reducer';
import systemAlertContactsRedux from 'Modules/accounts/.components/systemAlertLogsTab/.components/contacts/redux/reducer';
import systemAlertLastReadingInfoRedux from 'Modules/accounts/.components/systemAlertLogsTab/.components/lastReadingInfo/redux/reducer';
import systemAlertGraphicViewRedux from 'Modules/accounts/.components/systemAlertLogsTab/.components/graphicView/redux/slice';
import accountDetailsRedux from 'Modules/accounts/views/main/.components/details/redux/reducer';
import accountExportLogsRedux from 'Modules/accounts/.components/exportLogs/redux/reducer';
import reprocessOdoHoursRedux from 'Modules/accounts/.components/reprocessOdoHours/redux/reducer';
import changeUsernameRedux from 'Modules/accounts/.components/changeUsername/redux/reducer';
import promilesRequestRedux from 'Modules/accounts/views/components/promilesRequest/redux/reducer';
import addIntegrationRedux from 'Modules/accounts/.components/addIntegration/redux/reducer';
import viewCerebrumXIntegrationRedux from 'Modules/accounts/.components/viewCerebrumXIntegration/redux/reducer';
import addCerebrumXOEMRedux from 'Modules/accounts/.components/addCerebrumXOEM/redux/reducer';
import deleteCerebrumXIntegrationRedux from 'Modules/accounts/.components/deleteCerebrumXIntegration/redux/reducer';
import syncEntitiesRedux from 'Modules/accounts/views/components/syncEntities/redux/slice';
import syncEntitiesSelectorRedux from 'Modules/accounts/views/components/syncEntities/.components/entitySelector/redux/slice';
import edgeTensorRedux from 'Modules/accounts/.components/tabEdgeTensor/redux/slice';
import edgeTensorVideoReviewRedux from 'Modules/accounts/.components/edgeTensorVideoReview/redux/slice';
import tabApiKeysRedux from 'Modules/accounts/.components/tabApiKeys/redux/slice';

//export redux objects
export default {
	accountOverviewRedux,
	purgeAccountRedux,
	createEditAccountRedux,
	changeStatusAccountRedux,
	resetCompAuthenticationRedux,
	advancedFiltersRedux,
	scheduledReportsRedux,
	systemAlertContactsRedux,
	systemAlertLastReadingInfoRedux,
	systemAlertGraphicViewRedux,
	accountDetailsRedux,
	accountExportLogsRedux,
	reprocessOdoHoursRedux,
	changeUsernameRedux,
	promilesRequestRedux,
	addIntegrationRedux,
	viewCerebrumXIntegrationRedux,
	addCerebrumXOEMRedux,
	deleteCerebrumXIntegrationRedux,
	syncEntitiesRedux,
	syncEntitiesSelectorRedux,
	edgeTensorRedux,
	edgeTensorVideoReviewRedux,
	tabApiKeysRedux
};